import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './style.scss';

// We need to forward ref explicitly
// So that we can use tooltips on top of buttons
// In the future our re-usable components will handle this
const InspectButton = React.forwardRef(
  (
    {
      type,
      children,
      isHeader,
      isFooter,
      isSave,
      isLoading,
      disabled,
      className,
      ...restProps
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      className={className}
      styleName={cn('inspect-button', {
        'is-header': isHeader,
        'is-footer': isFooter,
        'is-save': isSave,
      })}
      disabled={disabled || isLoading}
      {...restProps}
    >
      {children}
    </button>
  ),
);

InspectButton.propTypes = {
  children: PropTypes.node,
  isHeader: PropTypes.bool,
  isFooter: PropTypes.bool,
  isSave: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
};

InspectButton.defaultProps = {
  disabled: false,
  isHeader: false,
  isFooter: false,
  isSave: false,
  isLoading: false,
  className: null,
  type: 'button',
};

export default InspectButton;
